import React, { ComponentType, FunctionComponent, useEffect, useState } from 'react'

import ArrowDownIcon from '@/atoms/icons/arrow-down.svg'

import { DropdownMenu, DropdownMenuList, ItemText, MenuItemWrapper, NavButton } from './private-layout-styles'

export interface Option {
  label: string
  name: string
  icon?: ComponentType
}

interface Props {
  isPublic?: boolean
  options: Array<Option>
  onChange: (option: Option) => void
  selectedOption: Option
  width?: number
}

export const DropDownSelect: FunctionComponent<Props> = ({ options, selectedOption, onChange, width, isPublic }) => {
  const [selectedValue, setSelectedValue] = useState(selectedOption)
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    setSelectedValue(selectedOption)
  }, [selectedOption])

  const handleChange = (option: Option) => {
    setSelectedValue(option)
    onChange(option)
    setIsHovered(false)
  }

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const LeftIcon = selectedValue?.icon
  const hasOneOption = options.length === 1

  return (
    <DropdownMenu onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <NavButton $isHovered={isHovered} $isPublic={isPublic} $hasOneOption={hasOneOption}>
        {LeftIcon && <LeftIcon />}
        <ItemText $hasIconLeft={!!selectedValue?.icon} $hasIconRight>
          {selectedValue?.label}
        </ItemText>
        {!hasOneOption && <ArrowDownIcon className={isHovered ? 'rotate' : ''} />}
      </NavButton>
      {isHovered && !hasOneOption && (
        <DropdownMenuList width={width}>
          {options
            .filter(({ name }) => name !== selectedValue?.name)
            .map(option => {
              const LeftIcon = option?.icon

              return (
                <MenuItemWrapper key={option?.name} $isPublic={isPublic} onClick={() => handleChange(option)}>
                  {LeftIcon && <LeftIcon />}
                  <ItemText $hasIconLeft={!!option?.icon}>{option?.label}</ItemText>
                </MenuItemWrapper>
              )
            })}
        </DropdownMenuList>
      )}
    </DropdownMenu>
  )
}
